<div class="comment-reply-wrapper">
  <mat-form-field>
    <mat-label>{{ reply.text.label }}</mat-label>
    <input
      matInput
      name="reply.text.name"
      [formControl]="reply.formControl"
      [value]="reply.formControl.value"
    />
  </mat-form-field>
  <div
    *ngIf="publicUsername || publicOrgnName; else commentActionButtons"
    class="comment-reply-public-metadata-form"
  >
    <mat-form-field *ngIf="publicUsername">
      <mat-label>{{ publicUsername.text.label }}</mat-label>
      <input
        matInput
        name="publicUsername.text.name"
        [formControl]="publicUsername.formControl"
        [value]="publicUsername.formControl.value"
      />
    </mat-form-field>
    <mat-form-field *ngIf="publicOrgnName">
      <mat-label>{{ publicOrgnName.text.label }}</mat-label>
      <input
        matInput
        name="publicOrgnName.text.name"
        [formControl]="publicOrgnName.formControl"
        [value]="publicOrgnName.formControl.value"
      />
    </mat-form-field>
    <ng-container [ngTemplateOutlet]="commentActionButtons"></ng-container>
  </div>

  <ng-template #commentActionButtons>
    <div class="comment-reply-buttons">
      <button
        *ngIf="enableCancel"
        mat-stroked-button
        matLine
        (click)="doAction('cancel')"
        style="margin-right: 0.5em"
      >
        CANCEL
      </button>
      <button
        mat-flat-button
        color="primary"
        matLine
        (click)="doAction('post')"
        [disabled]="!canProceed()"
      >
        {{ inputComment ? 'SAVE' : 'COMMENT' }}
      </button>
    </div>
  </ng-template>
</div>
